import { Center, Flex, Space } from '@mantine/core';
import { WeightIndicator } from 'models/weight';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Indicator } from 'utils/models';

interface Props {
  icon?: ReactElement;
  indicator: Indicator | WeightIndicator;
  space: number;
  label?: string;
}

export const IndicatorLabelContent = ({ icon, indicator, space, label }: Props) => {
  const { t } = useTranslation();
  return (
    <Flex>
      <Center>{icon}</Center>
      <Space w={space} />
      {label || t(`indicator_label_${indicator}`)}
    </Flex>
  );
};
